import { QueryResult } from '@apollo/client';
import { mapProductFeatureGroupsToProductFeatures } from 'components/domain/fdr-geo/fdr-geo.utils';
import { IFdrProductRecommenderProduct } from 'components/domain/fdr-page-components/recommenders/product/fdr-product-recommender.types';
import { isFdrAdventureTravelProduct } from 'components/domain/fdr-product/fdr-product.utils';
import { FdrBlogArticleFragment } from 'schemas/fragment/blog-articles/fdr-all-blog-articles.generated';
import {
  FdrProductBlogArticlesQuery,
  FdrProductBlogArticlesQueryVariables,
} from 'schemas/query/product/fdr-product-blog-articles.generated';
import {
  FdrProductRecommendedProductsQuery,
  FdrProductRecommendedProductsQueryVariables,
} from 'schemas/query/product/fdr-product-recommended-products.generated';
import { EFdrProductType } from './fdr-pdp.types';

export function getFdrProductType(id: string | Array<string>): EFdrProductType {
  if (!id || typeof id !== 'string') return null;

  const objectType = id.split('-')[0];
  return {
    a: EFdrProductType.AdventureTravel,
    o: EFdrProductType.RoundTrip,
    h: EFdrProductType.Hotel,
  }[objectType];
}

interface ICheckProductType {
  isHotel: boolean;
  isAdventureTravel: boolean;
  isRoundTrip: boolean;
}

export function checkProductType(id: string): ICheckProductType {
  return {
    isHotel: getFdrProductType(id) === EFdrProductType.Hotel,
    isAdventureTravel:
      getFdrProductType(id) === EFdrProductType.AdventureTravel,
    isRoundTrip: getFdrProductType(id) === EFdrProductType.RoundTrip,
  };
}

export const createProductBlogVariables = (
  id: string,
  page: number,
  perPage: number
) => {
  return {
    id,
    blogArticleInput: {
      pagination: {
        page,
        perPage,
      },
    },
  };
};

export const mapFdrProductBlogResponseToArticles = (
  data: QueryResult<
    FdrProductBlogArticlesQuery,
    FdrProductBlogArticlesQueryVariables
  >['data']
): FdrBlogArticleFragment[] => {
  if (isFdrAdventureTravelProduct(data?.fdrProduct)) {
    return data.fdrProduct.relatedBlogArticles.blogArticles || [];
  }

  return [];
};

export const mapFdrProductRecommendedProducts = (
  data: QueryResult<
    FdrProductRecommendedProductsQuery,
    FdrProductRecommendedProductsQueryVariables
  >['data']
): IFdrProductRecommenderProduct[] => {
  if (isFdrAdventureTravelProduct(data?.fdrProduct)) {
    return (
      data.fdrProduct.startingDestination.country.products.productsPage
        ?.filter(isFdrAdventureTravelProduct)
        .map(p => ({
          ...p,
          link: p.webMeta.descriptionWebMeta.link,
          image: p.images[0],
          features: mapProductFeatureGroupsToProductFeatures(p.featureGroups),
          route: p.route?.map(r => r.locationName),
        })) || []
    );
  }

  return [];
};
